// extracted by mini-css-extract-plugin
export default {"cat":"Categories_cat__8Ln4R"};